import { Dispatch, SetStateAction, useState } from 'react';

import { paginationStorage } from '../storage/local-storage/pagination-storage.util';
import { largeItemsToFetchMap } from '../types/general.types';

export const usePagination = (
  fetchAmount: 'large' = 'large',
): [
  number,
  Dispatch<SetStateAction<number>>,
  number,
  Dispatch<SetStateAction<number>>,
  number[],
  () => void,
] => {
  const storagePage = paginationStorage.get() || 1;

  const [currentPage, setPage] = useState(storagePage);

  const [itemsToFetch, setItemsToFetch] = useState(
    fetchAmount === 'large' ? largeItemsToFetchMap[1] : 5,
  );

  const handlePageChange: Dispatch<SetStateAction<number>> = (value) => {
    setPage((prev) => {
      const nextPage = Math.max(typeof value === 'function' ? value(prev) : value, 1);
      paginationStorage.set(nextPage);
      return nextPage;
    });
  };

  const resetCounter = () => {
    setPage(1);
    paginationStorage.set(1);
  };

  return [
    currentPage,
    handlePageChange,
    itemsToFetch,
    setItemsToFetch,
    largeItemsToFetchMap,
    resetCounter,
  ];
};
